import React, { useState, useEffect } from "react";
import PrintLayout from "../../core/printLayout";
import dayjs from "dayjs";
import { to12HourFormat } from "../../utils/common";

const PrintBilling = ({ show, handleClose, appointment, expense }) => {
    // function getAge(dateString) {
    //   var today = new Date();
    //   var birthDate = new Date(dateString);
    //   var age = today.getFullYear() - birthDate.getFullYear();
    //   var m = today.getMonth() - birthDate.getMonth();
    //   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //       age--;
    //   }
    //   return age;
    // }
    const [selectedIndexes, setSelectedIndexes] = useState(
        expense?.treatment?.map((_, idx) => idx) || [],
    );

    const toggleTreatment = (index) => {
        setSelectedIndexes((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index],
        );
    };

    const selectedTreatments =
        expense?.treatment?.filter((_, index) =>
            selectedIndexes.includes(index),
        ) || [];

    const totalCost = selectedTreatments.reduce(
        (sum, item) => sum + item.unit * item.cost,
        0,
    );

    const totalDiscount = selectedTreatments.reduce(
        (sum, item) => sum + item.discount,
        0,
    );

    const totalTax = selectedTreatments.reduce(
        (sum, item) => sum + item.tax,
        0,
    );

    const grandTotal = totalCost - totalDiscount + totalTax;

    function getAge(dateString) {
        if (!dateString || dateString === "Invalid date") return 0;

        const birthDate = new Date(dateString);
        if (isNaN(birthDate.getTime())) return 0; // Invalid date fallback

        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    const expenseview = () => {
        return `<div style = "padding : 24px; padding-top : 30px; max-width : 900px;">
            <div style="display: flex; justify-content: space-between;">
          <div style="border-radius: 8px; width: 45%;">
            <p style="color: grey; font-size: 14px;">
              <span style="color: #0288d1;">Patient Name:</span> ${
                  appointment?.patient?.firstName +
                  " " +
                  appointment?.patient?.lastName
              }
            </p>
            <p style="color: grey; font-size: 14px;">
              <span style="color: #0288d1;">Mobile No :</span> ${
                  appointment?.patient?.phoneNo || ""
              }
            </p>
            <p style="color: grey; font-size: 14px;">
              <span style="color: #0288d1;">Address :</span> ${(
                  appointment?.patient?.address || ""
              ).toUpperCase()}
            </p>
          </div>
          <div style="border-radius: 8px; width: 45%;">
            <p style="color: grey; font-size: 14px;">
              <span style="color: #0288d1;">Age/Gender : </span>${
                  (appointment.patient.birthDate &&
                  !isNaN(new Date(appointment.patient.birthDate).getTime()) &&
                  getAge(appointment.patient.birthDate) > 0
                      ? getAge(appointment.patient.birthDate) + " years"
                      : appointment.patient.age != null
                        ? appointment.patient.age + " years"
                        : "0 years") +
                  " / " +
                  appointment.patient.gender
              }
            </p>
            <p style="color: grey; font-size: 14px;">
              <span style="color: #0288d1;">Patient ID:</span> ${
                  appointment?.patient?.patientNumber
              }
            </p>
            <p style="color: grey; font-size: 14px;">
              <span style="color: #0288d1;">Date and Time:</span> ${
                  dayjs(appointment?.date?.toLocaleString()).format(
                      "DD-MM-YYYY",
                  ) +
                  "/" +
                  to12HourFormat(appointment.time)
              }
            </p>
          </div>
            </div>
              <p style="color: grey; font-size: 14px;">
              <span style="color: #0288d1;">By:</span>Dr. ${
                  appointment.doctor.name
              }
            </p>
            <hr/>
    
    <div style="margin-top: 8px; max-width : 700px;">
      <h5>Invoice</h5>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;font-size:16px;">
        <thead>
          <tr style="background-color: #f2f2f2; text-align: left;">
            <th style="border: 1px solid #ddd; padding: 8px;">#</th>
            <th style="border: 1px solid #ddd; padding: 8px;">Treatments & Products</th>
            <th style="border: 1px solid #ddd; padding: 8px;">Unit Cost (₹)</th>
            <th style="border: 1px solid #ddd; padding: 8px;">Discount</th>
            <th style="border: 1px solid #ddd; padding: 8px;">Total Cost (₹)</th>
          </tr>
        </thead>
        <tbody>
          ${expense?.treatment
              ?.map((item, index) => {
                  if (!selectedIndexes.includes(index)) return ""; // skip if not selected
                  return `
      <tr>
        <td style="border: 1px solid #ddd; padding: 8px;">${index + 1}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.name}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.cost}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.discount}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">
          ${(item.unit * item.cost - item.discount + item.tax).toFixed(2)}
        </td>
      </tr>
    `;
              })
              .join("")}

        </tbody>
      </table>
    </div>
    
    <div style="margin-top: 8px; border-top: 1px solid #ddd; padding-top: 15px;max-width:700px; font-size:16px;">
      <h5 style="font-weight: 700;">Summary</h5>
      <div style="display: flex; justify-content: space-between;">
        <div style="font-size:16px;">
          <p>Total Cost: ₹${totalCost}</p>
          <p>Discount: ₹${totalDiscount}</p>
          <p>Tax: ₹${totalTax}</p>
        </div>
        <div>
          <p style="font-size:16px;">Grand Total: ₹${grandTotal}</p>
        </div>
      </div>
    </div>
    
    <div style="margin-top: 8px; border-top: 1px solid #ddd; padding-top: 15px;font-size:16px;">
      <h5 style="font-weight: 700;">Payment Details</h5>
      <p>Invoice Number: ${expense?.invoiceNumber}</p>
      <p>Mode of Payment: ${expense?.paymentMethod}</p>
      <p>Amount Paid: ₹${expense?.amountPaid}</p>
      <p>Due Amount: ₹${
          (
              expense.totalCost -
              expense.totalDiscount +
              expense.totalTax
          ).toFixed(2) - expense.amountPaid
      }</p>
    </div>
    
    
    `;
    };

    return (
        <>
            {show && (
                <div
                    className="modal show d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{ overflow: "scroll", backdropFilter: "blur(20px)" }}
                >
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Billing</h5>
                                <button type="button" onClick={handleClose}>
                                    <i class="fa fa-window-close"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="container mt-4">
                                    <PrintLayout
                                        html={expenseview}
                                        category={"expense"}
                                    ></PrintLayout>
                                    {appointment && (
                                        <>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        borderRadius: "8px",
                                                        width: "45%",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: "grey",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "#0288d1",
                                                            }}
                                                        >
                                                            Patient Name:
                                                        </span>{" "}
                                                        {appointment?.patient
                                                            ?.firstName +
                                                            " " +
                                                            appointment?.patient
                                                                ?.lastName}
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: "grey",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "#0288d1",
                                                            }}
                                                        >
                                                            Mobile No :
                                                        </span>{" "}
                                                        {
                                                            appointment?.patient
                                                                ?.phoneNo
                                                        }
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: "grey",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "#0288d1",
                                                            }}
                                                        >
                                                            Address :
                                                        </span>{" "}
                                                        {(
                                                            appointment?.patient
                                                                ?.address || ""
                                                        ).toUpperCase()}
                                                    </p>
                                                </div>
                                                <div
                                                    style={{
                                                        borderRadius: "8px",
                                                        width: "45%",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            color: "grey",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "#0288d1",
                                                            }}
                                                        >
                                                            Age/Gender :{" "}
                                                        </span>
                                                        {(appointment.patient
                                                            .birthDate &&
                                                        appointment.patient
                                                            .birthDate !==
                                                            "Invalid date" &&
                                                        getAge(
                                                            appointment.patient
                                                                .birthDate,
                                                        ) > 0
                                                            ? `${getAge(appointment.patient.birthDate)} years`
                                                            : appointment
                                                                    .patient.age
                                                              ? `${appointment.patient.age} years`
                                                              : "0 years") +
                                                            " / " +
                                                            appointment.patient
                                                                .gender}
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: "grey",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "#0288d1",
                                                            }}
                                                        >
                                                            Patient ID:
                                                        </span>{" "}
                                                        {
                                                            appointment?.patient
                                                                ?.patientNumber
                                                        }
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: "grey",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "#0288d1",
                                                            }}
                                                        >
                                                            Date and Time:
                                                        </span>{" "}
                                                        {dayjs(
                                                            appointment?.date?.toLocaleString(),
                                                        ).format("DD-MM-YYYY") +
                                                            "/" +
                                                            to12HourFormat(
                                                                appointment.time,
                                                            )}
                                                    </p>
                                                </div>
                                            </div>
                                            <p
                                                style={{
                                                    color: "grey",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                <span
                                                    style={{ color: "#0288d1" }}
                                                >
                                                    By:
                                                </span>{" "}
                                                Dr.{appointment?.doctor?.name}
                                            </p>
                                        </>
                                    )}

                                    <hr />
                                    <div className="invoice-section mt-3">
                                        <h5>Invoice</h5>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>
                                                        Treatments & Products
                                                    </th>
                                                    <th>Unit Cost (₹)</th>
                                                    <th>Discount</th>
                                                    <th>Total Cost (₹)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {expense?.treatment?.map(
                                                    (item, index) => (
                                                        <tr key={item.id}>
                                                            <td>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        value={
                                                                            index
                                                                        }
                                                                        checked={selectedIndexes.includes(
                                                                            index,
                                                                        )}
                                                                        onChange={(
                                                                            e,
                                                                        ) => {
                                                                            // handle selection logic here
                                                                            toggleTreatment(
                                                                                index,
                                                                            );
                                                                        }}
                                                                    />
                                                                </td>
                                                            </td>
                                                            <td>{item.name}</td>
                                                            <td>{item.cost}</td>
                                                            <td>
                                                                {item.discount}
                                                            </td>
                                                            <td>
                                                                {(
                                                                    item.unit *
                                                                        item.cost -
                                                                    item.discount +
                                                                    item.tax
                                                                ).toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    ),
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="summary-section mt-3 border-top pt-3">
                                        <h5 style={{ fontWeight: 700 }}>
                                            Summary
                                        </h5>
                                        <div className="row">
                                            <div className="col-6">
                                                <p>Total Cost: ₹{totalCost}</p>
                                                <p>
                                                    Discount: ₹{totalDiscount}
                                                </p>
                                                <p>Tax: ₹{totalTax}</p>
                                            </div>
                                            <div className="col-6">
                                                <p>
                                                    Grand Total: ₹{grandTotal}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="payment-section mt-3 border-top pt-3">
                                        <h5 style={{ fontWeight: 700 }}>
                                            Payment Details
                                        </h5>
                                        <p>
                                            Invoice Number:{" "}
                                            {expense?.invoiceNumber}
                                        </p>
                                        <p>
                                            Mode of Payment:{" "}
                                            {expense?.paymentMethod}
                                        </p>
                                        <p>
                                            Amount Paid: ₹{expense?.amountPaid}
                                        </p>
                                        <p>
                                            Due Amount : ₹
                                            {(
                                                expense.totalCost -
                                                expense.totalDiscount +
                                                expense.totalTax
                                            ).toFixed(2) - expense.amountPaid}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PrintBilling;
